<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M3 5.4c0-.6.5-1 1-1h9.6c.6 0 1 .4 1 1v10.2H4.4c-.8 0-1.4-.6-1.4-1.4z"/><path d="M14.6 7.6h1.6c.7 0 1.2.5 1.2 1.2v5.2c0 .9-.7 1.6-1.6 1.6"/><path d="M5.6 7.6h6.4M5.6 10.4h6.4M5.6 13h4"/></svg>
</template>
